"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _alignLeft = _interopRequireDefault(require("@atlaskit/icon/core/align-left"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const OverviewIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
}, props, {
  newIcon: _alignLeft.default
}));
OverviewIcon.displayName = 'OverviewIcon';
var _default = exports.default = OverviewIcon;